import { isArray } from 'lodash/fp';
import portableTextToPlain from '@ahmdigital/logic/lib/content/utils/portable-text-to-plain';
import type { FAQPage, WithContext } from 'schema-dts';

import type { FaqItem } from '../../../../types/question';

const buildFaqPageSchema = (faqs: FaqItem[]): WithContext<FAQPage> => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    acceptedAnswer: {
      '@type': 'Answer',
      text: isArray(faq.body) ? portableTextToPlain(faq.body) : faq.body,
    },
    name: faq.title,
  })),
});

export default buildFaqPageSchema;
